module.exports = __webpack_public_path__ + "static/img/products application_Semi-rigid PVC1.8bf65ffd.jpg";